import axios from "axios";

const formValues = (formData) => {
  return  `Number of Sites: ${formData.numberOfSites}, Average Downtime Cost Per Hour: ${formData.averageDowntime}, Current Uptime: ${formData.currentUptime}, Maximum Uptime Potential Per Site: ${formData.maximumUptime}, Current Service Level: ${formData.currentServiceLevel}, Recommended Service Level: ${formData.recommendedServiceLevel}`
}

const calculatedValues = (formData) => { 
  return `
    Maximum available production hours for all sites: ${formData.maximumAvailableProductionHours}
    Down time hours: ${formData.downtimeHoursItem}
    Down time costs: ${formData.downtimeCostsItem}
    Reverse Current Service Level: ${formData.reverseCurrentServiceLevelItem}
    Reverse Recommended Service Level: ${formData.reverseRecommendedServiceLevelItem}
    Optimized Down time hours: ${formData.optimizedDowntimeHoursItem}
    Optimized Down time costs: ${formData.optimizedDowntimeCostsItem}
    Avoidable Down time costs: ${formData.avoidableDowntimeCostsItem}
    Risk Adjustment: ${formData.riskAdjustment}
    Potential Avoidable Down time With Verusen: ${formData.potentialAvoidableDowntimeWithVerusenItem}
    `
}

export const useForm = () => {


  const sendToHubSpot = (formData) => {
    const portalId = "2886100"; // replace with your HubSpot portal ID
    const formGuid = "b22046c9-f5c0-4659-b80a-2bfdfdf53b43"; // replace with your HubSpot form GUIDplace with your HubSpot form GUID
    const endpoint = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
    const data = {
      fields: [
        { name: "firstname", value: formData.firstname },
        { name: "lastname", value: formData.lastname },
        { name: "email", value: formData.email },
        { name: "company", value: formData.company },
        {
          name: "cost_saving_calculator",
          value: `FORM_VALUES:\n ${formValues(formData)}\n , CALCULATED_VALUES:\n ${calculatedValues(formData)}`,
        },
      ],
      skipValidation: true, // Skip HubSpot validation; set to false if you want to validate data
    };
    axios
      .post(endpoint, data)
      .then((response) => {
      sessionStorage.setItem(
        "downtimeHours",
        formData.downtimeHoursItem
      );

      sessionStorage.setItem(
        "downtimeCosts",
        formData.downtimeCostsItem
      );

      sessionStorage.setItem(
        "reverseCurrentServiceLevel",
        formData.reverseCurrentServiceLevelItem
      );

      sessionStorage.setItem(
        "reverseRecommendedServiceLevel",
        formData.reverseRecommendedServiceLevelItem
      );

      sessionStorage.setItem(
        "optimizedDowntimeHours",
        formData.optimizedDowntimeHoursItem
      );

      sessionStorage.setItem(
        "optimizedDowntimeCosts",
        formData.optimizedDowntimeCostsItem
      );

      sessionStorage.setItem(
        "avoidableDowntimeCosts",
        formData.avoidableDowntimeCostsItem
      );

      sessionStorage.setItem(
        "riskAdjustment",
        formData.riskAdjustment
      );

      sessionStorage.setItem(
        "potentialAvoidableDowntimeWithVerusen",
        formData.potentialAvoidableDowntimeWithVerusenItem
      );

      sessionStorage.setItem(
        "potentialAvoidableDowntimeWithVerusenItemToText",
        formData.potentialAvoidableDowntimeWithVerusenItemToText
      );

     
        window.location.href = "https://verusen.com/?page_id=4018";
      })
      .catch((error) => {
        console.error("Error sending data to HubSpot:", error);
      });
  };

  return { sendToHubSpot };
};
